// @ts-nocheck
import React from 'react';
import TextField from '@material-ui/core/TextField';
import {
  CircularProgress,
  InputAdornment,
  makeStyles,
  Box,
} from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { grey } from 'assets/colors/colors';
import { ErrorTooltip } from '../__v2__/ErrorTooltip';

const useStyles = makeStyles(() => ({
  positiveRoot: ({ alignCenter }) => ({
    '& .MuiOutlinedInput-input': {
      textAlign: alignCenter ? 'center' : '',
      borderRadius: '0.25rem',
    },
  }),
  root: {
    '& .MuiInputBase-root': {
      color: 'red !important',
    },
    '& .MuiInputAdornment-positionStart': {
      color: 'red !important',
    },
    '& .MuiTypography-colorTextSecondary': {
      color: 'red !important',
    },
  },
  disabledField: {
    backgroundColor: grey.g200,
    '&:focus': {
      outline: 'none',
    },
  },
}));

const typeArr = ['text', 'password'];

interface InputFieldProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'outlined' | 'filled' | 'standard' | 'table';
  loading?: boolean;
  invalid?: boolean;
  applyDisableStyleToPoNumber?: boolean;
  alignCenter?: boolean;
  isSearch?: boolean;
}

function InputField({
  variant = 'outlined',
  readOnly,
  id,
  startAdornment,
  endAdornment,
  loading,
  disabled,
  invalid,
  error,
  helperText,
  onChange,
  value,
  inputRef,
  InputProps,
  applyDisableStyleToPoNumber = false,
  alignCenter = false,
  style = {},
  onFocus,
  type,
  ...rest
}: InputFieldProps) {
  const classes = useStyles({ alignCenter });
  const startAdornmentStyle = {
    marginRight: 0,
  };

  const getClassName = () => {
    if (disabled) {
      return value < 0
        ? `${classes.disabledField} ${classes.root}`
        : classes.disabledField;
    }
    if (value < 0 && !typeArr.includes(type) && !rest.isSearch) {
      return classes.root;
    }
    return classes.positiveRoot;
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      className={applyDisableStyleToPoNumber ? 'disabledTextFieldStyle' : ''}
    >
      <TextField
        className={getClassName()}
        id={id}
        style={{
          margin: 0,
          textAlign: 'right',
          ...style,
        }}
        color={value < 0 ? 'primary' : 'secondary'}
        margin="normal"
        autoComplete="off"
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly,
          startAdornment: startAdornment ? (
            <InputAdornment position="start" style={startAdornmentStyle}>
              {startAdornment}
            </InputAdornment>
          ) : null,
          endAdornment:
            endAdornment || loading ? (
              <InputAdornment position="end">
                {endAdornment}
                {loading && <CircularProgress size={14} />}
              </InputAdornment>
            ) : null,
          ...InputProps,
        }}
        type={type}
        {...rest}
        disabled={loading || disabled}
        error={invalid}
        // helperText={error?.message || helperText || ''}
        onChange={onChange}
        value={value}
        inputRef={inputRef}
        variant={variant === 'table' ? undefined : variant}
        onFocus={onFocus}
      />
      {(error?.message || helperText) && (
        <ErrorTooltip
          tooltip
          title={error?.message || helperText}
          aria-label="add"
          placement="bottom"
          arrow
        >
          <Info
            fontSize="small"
            style={{ color: 'red', margin: '7px 0px 0px 2px' }}
          />
        </ErrorTooltip>
      )}
    </Box>
  );
}

export default InputField;
